import React from 'react';
import { useSelector } from 'react-redux';

import StarsWizard from '@swf/components/StarsWizard/StarsWizard';
import { select } from '@swf/core/store';
import type { GroupProps } from '@swf/core/types/Wizard';

import Transition from './components/Transition/Transition';

const WizardGroup: React.FC<React.PropsWithChildren<GroupProps>> = (props) => {
  const isMobileEmbedded = useSelector(select.device.isMobileEmbedded);
  return <StarsWizard.Group {...props} transition={isMobileEmbedded ? Transition : undefined} />;
};
export default WizardGroup;
